if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('.product-text-buy-btn-label') || this.submitButton.querySelector('p.t2') || this.submitButton.querySelector('span');
        this.quantityControlsEnabled = this.dataset.quantityControls === 'true';
        this.quantityShell = this.querySelector('[data-pdp-quantity-shell]');
        this.quantityControls = this.querySelector('.product-buy-quantity-controls');
        this.quantityValue = this.querySelector('.product-buy-quantity-value');
        this.quantityIncreaseButton = this.querySelector('[data-action="increase"]');
        this.quantityDecreaseButton = this.querySelector('[data-action="decrease"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.quantityControlsEnabled) {
          this.bindQuantityControls();
          this.syncQuantityState();
          document.addEventListener('cart:changed', (event) => this.applyQuantityState(event.detail && event.detail.cart));
          document.addEventListener('variant:change', () => this.syncQuantityState());
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        const productVariantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity') || 1, 10) || 1;
        const productType = this.dataset.productType || '';
        const requiresShipping = this.dataset.requiresShipping !== 'false';

        // Оптимистичная batch-модель: товар идёт в pending CartStore (без сети).
        // Реальный запрос уйдёт ПАЧКОЙ при открытии drawer / checkout / уходе.
        if (window.CartStore && productVariantId) {
          window.CartStore.addItems([
            {
              id: parseInt(productVariantId, 10),
              quantity: quantity,
              product_type: productType,
              requires_shipping: requiresShipping,
            },
          ], { immediate: true });
        }

        const quickAddModal = this.closest('quick-add-modal');
        const quickAddProductId = quickAddModal?.id?.match(/^QuickAdd-(\d+)/)?.[1] || null;

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: productVariantId,
          productId: quickAddProductId,
          // displayCart для аналитики (cart-analytics использует token/total/items)
          cartData: window.CartStore ? window.CartStore.getCart() : undefined,
        });

        // Закрываем quick-add модалку (если есть) и открываем drawer —
        // он дофлашит pending и наполнится актуальной корзиной.
        if (quickAddModal) quickAddModal.hide(true);

        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.openAfterAdd === 'function') {
          cartDrawer.openAfterAdd(this.submitButton);
        } else if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }

        // Сброс состояния кнопки (добавление оптимистичное — без ожидания сети).
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
        this.syncQuantityState();
      }

      bindQuantityControls() {
        if (this.quantityIncreaseButton) {
          this.quantityIncreaseButton.addEventListener('click', (event) => this.onQuantityButtonClick(event, 1));
        }
        if (this.quantityDecreaseButton) {
          this.quantityDecreaseButton.addEventListener('click', (event) => this.onQuantityButtonClick(event, -1));
        }
      }

      syncQuantityState() {
        if (!this.quantityControlsEnabled || !window.CartStore) return;
        const apply = () => this.applyQuantityState(window.CartStore.getCart());
        if (typeof window.CartStore.ready === 'function') {
          Promise.resolve(window.CartStore.ready()).then(apply).catch(apply);
        } else {
          apply();
        }
      }

      applyQuantityState(cart) {
        if (!this.quantityControlsEnabled) return;

        const quantity = this.getCurrentCartQuantity(cart);
        const isAdded = quantity > 0;

        this.submitButton.classList.toggle('is-added', isAdded);
        this.submitButton.hidden = isAdded;
        if (this.submitButtonText) this.submitButtonText.style.display = isAdded ? 'none' : '';

        if (this.quantityShell) {
          this.quantityShell.hidden = !isAdded;
          this.quantityShell.style.display = isAdded ? 'flex' : 'none';
          this.quantityShell.classList.toggle('is-added', isAdded);
        }
        if (this.quantityControls) {
          this.quantityControls.hidden = !isAdded;
          this.quantityControls.style.display = isAdded ? 'flex' : 'none';
        }
        if (this.quantityValue) this.quantityValue.textContent = String(Math.max(1, quantity || 1));
      }

      onQuantityButtonClick(event, delta) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        if (!window.CartStore || !this.currentVariantId) return;

        const currentQuantity = this.getCurrentCartQuantity(window.CartStore.getCart());
        const meta = this.currentProductMeta();
        if (delta > 0) {
          window.CartStore.addItems([{ id: this.currentVariantId, quantity: 1, ...meta }], { immediate: true });
        } else {
          const nextQuantity = Math.max(0, currentQuantity - 1);
          window.CartStore.setQty(this.currentVariantId, nextQuantity, meta);
        }
        this.syncQuantityState();
      }

      getCurrentCartQuantity(cart) {
        const variantId = String(this.currentVariantId || '');
        if (!variantId || !cart || !Array.isArray(cart.items)) return 0;
        const line = cart.items.find((item) => String(item.variant_id != null ? item.variant_id : item.id) === variantId);
        return line ? Number(line.quantity) || 0 : 0;
      }

      currentProductMeta() {
        return {
          product_id: this.dataset.productId,
          product_type: this.dataset.productType || '',
          requires_shipping: this.dataset.requiresShipping !== 'false',
          price: Number(this.submitButton && this.submitButton.dataset ? this.submitButton.dataset.price : 0) || 0,
        };
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      get currentVariantId() {
        return this.variantIdInput ? this.variantIdInput.value : null;
      }

      /**
       * Проактивное добавление упаковки в тот же запрос при добавлении товара
       * Использует PackagingUtils для определения нужных упаковок
       */
      async checkAndAddAdditionalProduct() {
        // Упаковка — на checkout, не при добавлении в корзину.
      }
    }
  );
}
